import script from "./BaseActionMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseActionMenu.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__